import { render, staticRenderFns } from "./RoundedButton.vue?vue&type=template&id=ae90dfd4"
import script from "./RoundedButton.vue?vue&type=script&lang=ts"
export * from "./RoundedButton.vue?vue&type=script&lang=ts"
import style0 from "./RoundedButton.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports